import ImageGrid from "./ImageGrid";
import {
  SectionCard,
  SectionCardSubTitle,
  SectionCardTitle,
} from "@/components";

const HealthGrow = () => {
  return (
    <>
    <SectionCard className="grid grid-cols-1 lg:grid-cols-2 relative">
      <div className="hidden lg:block h-[130px] w-[130px] bg-primary rounded-full absolute -top-15 left-0 float-animation" />
      <div className="flex flex-col items-center lg:items-start">
          {/* <SectionCardSubTitle className="mt-5 mb-5 text-center lg:text-left">
            Why Choose Intron
          </SectionCardSubTitle> */}
          <SectionCardTitle className="mt-10 mb-10 text-center lg:text-left lg:w-[400px]">
            Driving Animal Health and Growth
          </SectionCardTitle>
        </div>
      <ImageGrid />
    </SectionCard>
    </>
  );
};

export default HealthGrow;
